import React, { useState } from 'react';
import { FaExclamationCircle, FaKey } from 'react-icons/fa';
import PinInput from './PinInput';

const PinLogin = ({ onPinSubmit, onFallback, error, loading, translations: t }) => {
    const [pin, setPin] = useState('');

    // This function is passed to PinInput and gets called when the PIN is 6 digits.
    const handlePinComplete = (completedPin) => {
        onPinSubmit(completedPin);
    };

    // This handles the click on the unlock button.
    const handleUnlockClick = () => {
        if (pin.length === 6) {
            onPinSubmit(pin);
        }
    };

    return (
        <>
            <h2 className="login-welcome">{t.unlockWithPin}</h2>
            <p className="login-subtitle">{t.enterPin}</p>
            {error && (<div className="error-message"><FaExclamationCircle size={18} /><span>{error}</span></div>)}
            <div className="form-group">
                <PinInput pin={pin} setPin={setPin} onPinComplete={handlePinComplete} />
            </div>
            <button type="button" className="login-button-expanded" onClick={handleUnlockClick} disabled={loading || pin.length !== 6}>
                {loading ? (<><span className="spinner" /><span>{t.loggingIn}</span></>) : (<><FaKey size={18} /><span>{t.unlock}</span></>)}
            </button>
             <a href="#" onClick={onFallback} className="forgot-password">{t.usePasswordInstead}</a>
        </>
    );
};

export default PinLogin;
